/**
 * InfoActor - A lightweight actor for replicating arbitrary game state without visual representation.
 * No visual components, hidden by default, does not tick or replicate by default.
 * Extend for game state holders (GameSessionInfo, PlayerInfo, etc.).
 */

import { EngineClass } from '../systems/ClassRegistry.js';

import { Actor } from './Actor.js';

import type { ActorOptions } from './Actor.js';

@EngineClass('InfoActor')
export class InfoActor extends Actor {
  public override initialize(options?: ActorOptions): void {
    super.initialize(options);

    // Hide this actor in game by default (no visual representation)
    this.setHiddenInGame(true);

    // InfoActor does not replicate by default
    // Subclasses should set this.replicated = true if they need replication
    this.replicated = false;
  }

  public override tickPrePhysics(_deltaTime: number): void {
    // No-op by default - subclasses can override if they need tick behavior
  }

  public override tickPostPhysics(_deltaTime: number): void {
    // No-op by default - subclasses can override if they need tick behavior
  }
}
